import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import lodashIsEqual from 'lodash/fp/isEqual';

import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';
import {
  SCREEN_ID_SEARCH_FILTERS,
  SCREEN_ID_FEED,
  SCREEN_ID_FEED_CATEGORY_MAP,
  SCREEN_ID_LISTINGS,
  SCREEN_ID_LISTINGS_MAP,
} from 'client/constants/screenIds';
import getLastPageVisitedByScreenIdList from 'common/util/getLastPageVisitedByScreenIdList';
import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withApiState from 'client/helpers/withApiState';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import { Search as SearchActions } from 'client/actions';

import NavbarButton from 'client/components/NavbarButton';
import Navbar from 'client/components/Navbar';
import SrSearchFilterList from 'client/components/SrSearchFilterList';

const screenIdList = [
  SCREEN_ID_FEED,
  SCREEN_ID_FEED_CATEGORY_MAP,
  SCREEN_ID_LISTINGS,
  SCREEN_ID_LISTINGS_MAP,
];

@withTransitionHook
@withApiState({
  resultsCountApiState: {
    action: SR_API_ACTION_GET_LISTING_LIST,
  },
})
@branch({
  filters: ['search', 'filters'],
  resultsCount: ['search', 'resultsCount'],
  currentUser: ['currentUser'],
  listingsViewMode: ['listingsViewMode'],
  screenIdHistory: ['analytics', 'screenIdHistory'],
  pathHistory: ['analytics', 'pathHistory'],
  currentUserMarket: ['markets', 'currentUserMarket'],
})
@withRouter
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
class SearchFiltersPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Filter Search | Sunroom Rentals',
    section: 'Listings',
    // canonical: '/',
    keywords: 'rent, home, austin, tour, apartment',
    description:
      'Spend less time scheduling tours, our rental experts ' +
      'will schedule and confirm tours for you.',
  });

  static propTypes = {
    filters: PropTypes.object.isRequired,
    resultsCount: PropTypes.number,
    resultsCountApiState: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    listingsViewMode: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    screenIdHistory: PropTypes.array.isRequired,
    pathHistory: PropTypes.array.isRequired,
    currentUserMarket: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this._onApplyFiltersClick = this._onApplyFiltersClick.bind(this);
  }

  async _onApplyFiltersClick() {
    const { dispatch } = this.props;

    await dispatch(SearchActions.applyFilters);
    this._onBack();
  }

  _onChangeFilter = (filterKey, filterValue) => {
    this.props.dispatch(SearchActions.updateFilter, {
      filterKey,
      filterValue,
    });
  };

  _onCancelFilters = () => {
    const { dispatch } = this.props;

    dispatch(SearchActions.cancelFilters);
    this._onBack();
  };

  _onBack = () => {
    const { history, screenIdHistory, pathHistory } = this.props;

    const lastPageVisited = getLastPageVisitedByScreenIdList({
      screenIdHistory,
      pathHistory,
      screenIdList,
    });

    if (lastPageVisited) {
      history.push(lastPageVisited.path);
    } else {
      history.push('/feed');
    }
  };

  render() {
    const {
      filters,
      currentUser,
      listingsViewMode,
      resultsCount,
      resultsCountApiState,
      currentUserMarket,
    } = this.props;

    const isDisable = lodashIsEqual(currentUser.searchFilters, filters);

    return (
      <div>
        <div className="modal filters">
          <Navbar
            leftButton={<NavbarButton onClick={this._onCancelFilters}>Cancel</NavbarButton>}
          />

          <div className="contentContainer">
            <SrSearchFilterList
              listingsViewMode={listingsViewMode}
              redirectTo="/search"
              isDisable={isDisable}
              filters={filters}
              resultsCount={resultsCount}
              resultsCountIsLoading={resultsCountApiState.inProgress}
              onSubmit={this._onApplyFiltersClick}
              onChange={this._onChangeFilter}
              market={currentUserMarket}
            />
          </div>
        </div>
      </div>
    );
  }
}

SearchFiltersPage.displayName = 'SearchFiltersPage';

export default SearchFiltersPage;
